import * as SC from '@components/common/buttons/CloseBtn.style';

type Props = {
  children: React.ReactNode;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const CloseBtn = ({ children, ...args }: Props) => {
  return <SC.Wrapper {...args}>{children}</SC.Wrapper>;
};

export default CloseBtn;
